import app, { Component } from 'apprun';
import { isValidElement, isDateRangeOverlap } from '../utils';
import { users } from '../api';
import moment from 'moment';

export default class CommonPropertyComponent extends Component {
  state = { dateFmt:'DD-MMM-YYYY' };

  view = (state) => {
    if (!state.item) {return;}
    return (
      <div>
        <form id="frm-common-props-date-edit" class="form-horizontal" style={{ width: '450px' }} autocomplete="off">
          <div class="row">
            <div class="col-sm-12">{state.item.dispName}</div>
            <div class="col-sm-12">
              <input
                $pikaday
                id="inpText"
                size="62"
                class="form-control"
                value={state.newVal}
                oninput={(e) => {
                  state.newVal = e.target.value;
                }}
              />
            </div>
          </div>
          <div class="row">
            <div id="inpTextErrMsg" class="text-danger col-sm-12"></div>
          </div>
          <div class="edit-buttons">
            <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
            </a>
            <a
              type="button"
              class="btn btn-primary btn-xs"
              style={
                state.item.required || state.item.value === ''
                  ? { display: 'none' }
                  : { display: 'inline-block' }
              }
              onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
            </a>
            <a
              type="button"
              class="btn btn-default btn-xs"
              onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
            </a>
          </div>
        </form>

        {
          state.item.fieldName === 'StartDate' ?
            <div>
              <p>Update History</p>
              <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
                <thead>
                  <tr>
                    <th>Employee Type</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Modified Date</th>
                    <th>Modified User</th>
                  </tr>
                </thead>
                <tbody>
                  {state.auditLog.map((item) => {
                    return (
                      <tr style={{ display: 'table-row' }}>
                        <td>{item.employeeType}</td>
                        <td>{item.startDate?.substring(0, 10)}</td>
                        <td>{item.endDate?.substring(0, 10)}</td>
                        <td>{item.modifiedDate?.substring(0, 10)}</td>
                        <td>{item.auditModifiedUser}</td>
                      </tr>
                    );
                  }
                  )}
                </tbody>
              </table></div> : ''
        }
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      state = { ...state, ...newState };

      if (state.item.fieldName === 'StartDate') {
        state.auditLog = await users.getAuditEmployeeType(state.personId);
      }

      return {
        ...state,
        ...newState,
        newVal: newState.item.value ? moment(newState.item.value).format('DD-MMM-YYYY') : null,
        picker: null,
      };
    },

    save: async (state) => {
      state.newVal = (document.getElementById('inpText') as HTMLInputElement).value;
      if (!state.newVal) {return;}

      const errDiv = (document.getElementById('inpTextErrMsg') as HTMLDivElement);
      if(errDiv){
        errDiv.innerHTML = '';
      }

      const history = await users.getOldEmployeeDateHistory(state.personId);
      const d = moment(state.newVal).format('YYYY-MM-DD');
      const startDate = state.extra.StartDate?state.extra.StartDate:'9999-12-31';
      const endDate = state.extra.EndDate?state.extra.EndDate:'9999-12-31';

      if (isValidElement('inpText','DateStr')) {

        if(state.item.fieldName ==='StartDate'){
          if(endDate < d){
            errDiv.innerHTML =  'End date cannot be before Start date';
            return;
          }

          if(isDateRangeOverlap(d, endDate, history)) {
            errDiv.innerHTML =  'Start date is between another period of employment';
            return;
          }

        }else{
          if(startDate > d){
            errDiv.innerHTML =  'End date cannot be before Start date';
            return;
          }

          if(isDateRangeOverlap(startDate, d, history)) {
            errDiv.innerHTML =  'Start date is between another period of employment';
            return;
          }
        }

        await state.caller.run(state.save, state.item, state.panelId, state.newVal);
      }
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };

}
